import useOnClickOutside from './useOnClickOutside';
export * from './useOnClickOutside';

export default useOnClickOutside;
